import React from 'react';
import '../styles/Background.css';

const Background = () => {
    return (
        <div className="background">
                {/* Dynamic circles as background */}
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
        </div>
    );
};

export default Background;